import { render } from "./CreateMaterial.vue?vue&type=template&id=44f649ac"
import script from "./CreateMaterial.vue?vue&type=script&lang=js"
export * from "./CreateMaterial.vue?vue&type=script&lang=js"

import "./CreateMaterial.vue?vue&type=style&index=0&id=44f649ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__